export const NAV_KEYS = Object.freeze({
  admin: 'admin',
  adminJobs: 'admin_jobs',
  adminProperties: 'admin_properties',
  adminUsers: 'admin_users',
  branding: 'branding',
  brandingGeneral: 'branding_general',
  brandingStaycast: 'branding_staycast',
  dataList: 'data_list',
  guestRequest: 'guest_request',
  guestRequestMenu: 'guest_request_menu',
  guestRequestOrders: 'guest_request_orders',
  guestRequestSettings: 'guest_request_settings',
  happenings: 'happenings',
  helpAndTraining: 'helpAndTraining',
  hotelDirectory: 'hotel_directory',
  inRoomDining: 'in_room_dining',
  inRoomDiningMenu: 'in_room_dining_menu',
  inRoomDiningOrders: 'in_room_dining_orders',
  inRoomDiningSettings: 'in_room_dining_settings',
  orderRemotes: 'order_remotes',
  orders: 'orders',
  products: 'products',
  reporting: 'reporting',
  selfService: 'self_service',
});

export const PRODUCTS_NAV = Object.freeze({
  happenings_channel: (group) => {
    const marketType = group.market_type;
    const platform = group.platform;
    const titles = {
      ocean: 'Hotel Videos',
      hospitality: 'Hotel Channels',
      defaultTitle: 'Channels',
    };
    if (platform === 'Ocean') {
      return titles.ocean;
    } else if (marketType === 'hospitality') {
      return titles.hospitality;
    }
    return titles.defaultTitle;
  },

  hotel_directory: (group) => {
    const marketType = group.market_type;
    const isGrid = group.isGrid;
    const titles = {
      hospitality: 'Hotel Directory',
      defaultTitle: 'Directory',
      hospitalGuidebook: 'Hospital Guidebook',
    };
    if (isGrid) {
      return titles.hospitalGuidebook;
    }
    if (marketType === 'hospitality') {
      return titles.hospitality;
    }
    return titles.defaultTitle;
  },

  ird: (group) => {
    const marketType = group.market_type;
    const titles = {
      healthcare: 'Retail Shopping',
      defaultTitle: 'In Room Dining',
    };
    if (marketType === 'healthcare') {
      return titles.healthcare;
    }
    return titles.defaultTitle;
  },

  branding: () => {
    const titles = {
      defaultTitle: 'Branding',
    };

    return titles.defaultTitle;
  },

  guest_request: () => {
    const titles = {
      defaultTitle: 'Guest Request',
    };

    return titles.defaultTitle;
  },

  reporting: () => {
    const titles = {
      defaultTitle: 'Reporting',
    };

    return titles.defaultTitle;
  },

  staycast: () => {
    const titles = {
      defaultTitle: 'Reporting',
    };

    return titles.defaultTitle;
  },
});
